import React from "react";
import MerchantLayout from "@/shared/components/merchant/MerchantLayout";
import Notifications from "@/shared/pages/Notifications";

const MERCHANT_NOTIFICATION_TYPES = ["DEPOSIT", "WITHDRAWAL", "SYSTEM"];

export default function MerchantNotifications() {
  return (
    <MerchantLayout currentPage="MerchantNotifications">
      <Notifications
        allowedTypes={MERCHANT_NOTIFICATION_TYPES}
        pageDescription="View your deposit, withdrawal, and system notifications"
      />
    </MerchantLayout>
  );
}
